<template>
  <div :class="headerClass">
    <div class="list-page-header__left">
      <h1 v-if="hasSlot('title')" class="list-page-header__title">
        <slot name="title" />
      </h1>

      <h2 v-if="hasSlot('subtitle')" class="list-page-header__subtitle">
        <slot name="subtitle" />
      </h2>

      <ks-loading-spinner class="list-page-header__loader" :loading="loading" />
    </div>

    <div v-if="hasSlot('buttons')" class="list-page-header__buttons">
      <slot name="buttons" />
    </div>
  </div>
</template>

<script>
  import KsLoadingSpinner from 'Components/KsLoadingSpinner'
  import { buildClassString } from 'Utils'

  export default {
    components: {
      KsLoadingSpinner,
    },
    data () {
      return {
        baseHeaderClass: 'list-page-header',
      }
    },
    computed: {
      hasSubtitle () {
        return this.subtitle && this.subtitle !== ''
      },
      hasTitle () {
        return this.title && this.title !== ''
      },
      headerClass () {
        const bemClasses = buildClassString(this.baseHeaderClass, [
          {
            className: 'center-on-mobile',
            testCondition: () => this.centerOnMobile,
            bem: true,
          },
        ])

        return `${this.baseHeaderClass} ${bemClasses}`
      },
    },
    methods: {
      hasSlot (name = 'default') {
        return !!this.$slots[name] || !!this.$scopedSlots[name]
      },
    },
    props: {
      centerOnMobile: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="scss" scoped>
@use "~Styles/colors";
@use "~Styles/variables";

  $dashboard-mobile-breakpoint: variables.$media-sm-width;

  .list-page-header {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: variables.$content__main__content-padding;
    width: 100%;

    @media screen and (max-width: $dashboard-mobile-breakpoint) {
      gap: variables.$content__main__content-padding;
    }

    &__left {
      align-items: center;
      display: grid;
      grid-template-columns: min-content auto;
    }

    &__title {
      grid-column: 1;
      grid-row: 1;

      font-size: variables.$page-title-font-size;
      font-weight: bold;
      line-height: variables.$page-title-line-height;
      margin-right: variables.$default-padding;
      white-space: nowrap;

      display: flex;
      align-items: center;

      margin-bottom: 4px;

      @media screen and (max-width: $dashboard-mobile-breakpoint) {
        font-size: variables.$page-title-font-size--mobile;
        line-height: variables.$page-title-line-height--mobile;
      }
    }

    &__loader {
      grid-column: 2;
      grid-row: 1;
    }

    &__subtitle {
      grid-column: 1 / span 2;
      grid-row: 2;

      // Remove these once the h* tags don't have default margins
      margin-bottom: 0;
      margin-top: 0;
    }

    &__buttons {
      align-items: center;
      display: flex;
      flex-grow: 0;

      > *:not(:first-child) {
        margin-left: variables.$default-padding;
      }
    }

    $p: &;

    &--center-on-mobile {
      @media screen and (max-width: $dashboard-mobile-breakpoint) {
        flex-direction: column;

        #{$p}__left {
          margin-bottom: variables.$content__main__content-padding;
        }

        #{$p}__title {
          justify-content: center;
          text-align: center;
        }

        #{$p}__subtitle {
          text-align: center;
        }
      }
    }
  }
</style>
